// getCookies :: () -> {str: str}
export const getCookies = () => {
  return Object.fromEntries(
    document.cookie.split(/; */).map(pair => pair.split('=')),
  )
}

// getCookie :: (str, str?) -> str
export const getCookie = (key, fallback) => {
  const cookies = getCookies()
  if (cookies[key]) return cookies[key]
  if (fallback) return fallback
  else throw new Error(`missing cookie: ${key}`)
}
